import { OnInit, Component, ViewChild } from '@angular/core';
import { LoaderService } from 'app/loader.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FilesService } from 'app/files.service';
import { DatatableComponent } from '@swimlane/ngx-datatable/src/components/datatable.component';
import * as moment from 'moment';

@Component({
  selector: 'app-boards',
  templateUrl: './boards.component.html',
  styleUrls: ['./boards.component.scss']
})
export class BoardsComponent implements OnInit {

  workout_id: String = null;
  responseData: any = null;
  boardData: any = null;
  month: String = moment().format("MMM");
  year: String = moment().format("YYYY").toLowerCase();
  fileName: String = this.year + '-' + this.month.toLowerCase() + '.json';
  filters: any = {
    male: true,
    female: true
  }

  // @ViewChild('table') table: DatatableComponent;
  @ViewChild('table') table: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loaderService: LoaderService,
    private filesService: FilesService
  ) { }

  ngOnInit() {
    this.workout_id = this.route.snapshot.params.workout_id;
    this.getResults();
    this.loaderService.setLoaded();
  }

  /**
  * ---------------------------------------------
  *
  * ---------------------------------------------
  */
  getResults() {
    if (!this.workout_id) {
      // console.log("No workout");
    } else {
      // console.log('https://hub-boards-files.s3.amazonaws.com/' + this.workout_id + '/' + this.fileName);
      this.filesService.getTextFile('https://hub-boards-files.s3.amazonaws.com/' + this.workout_id + '/' + this.fileName) //wo-maxramp
        .subscribe(
          response => {
            this.boardData = JSON.parse(response._body);
            // console.log(JSON.parse(response._body));
            this.responseData = JSON.parse(response._body);
            this.loaderService.setLoaded();
          },
          error => {
            // console.log("error: ", error);
          }
        )
    }
    this.loaderService.setLoaded();
  }

  /**
  * ---------------------------------------------
  *
  * ---------------------------------------------
  */
  updateBoardData(event) {
    // console.log("male: ", this.filters.male);
    // console.log("female: ", this.filters.female);
    this.boardData.data = [];
    // let tempdata = [];

    for (let i = 0; i < this.responseData.data.length; i++) {
      if(this.filters.male && this.responseData.data[i].user_obj.gender == 'm'){
        this.boardData.data.push(this.responseData.data[i]);
      }
      if(this.filters.female && this.responseData.data[i].user_obj.gender == 'f'){
        this.boardData.data.push(this.responseData.data[i]);
      }
    }

    // hack to programatically re-sort the table orrectly after data changing
    setTimeout(() => {
      this.table.rows = [...this.table.rows];
    }, 0);

  }

  /**
  * ---------------------------------------------
  * Navigate to selected session when the table row is clicked
  * ---------------------------------------------
  */
  onActivate(event) {
    if (event.type == 'click') {
      let target = event.event.target.tagName.toLowerCase();

      if (target != 'label' && target != 'input') {
        this.router.navigate(['/session', event.row._id.sessionId])
      }
    }
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/boards/boards.component.ts